import classNames from 'classnames';
import React from 'react';
import styles from './RecentSearches.scss.js';
import ClearQueryIcon from '../../../IconsDeprecated/ClearQueryIcon.js';
import ClockIcon from '../../../IconsDeprecated/ClockIcon.js';
import Button from '../../../Button/Button.js';

const RecentSearches = _ref => {
  let {
    recentSearches = [''],
    onClearHistory = () => {},
    onSelect = () => {},
    onDeleteRecentSearch = () => {},
    dropdownTitle = '',
    dropdownButtonText = ''
  } = _ref;
  const mapRecentSearchesToList = () => {
    if (recentSearches) {
      const result = recentSearches.map((element, index) => /*#__PURE__*/React.createElement("div", {
        className: classNames(styles['recent-searches-list'])
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(styles['recent-searches-list']),
        onClick: () => onSelect(element),
        role: "button",
        onMouseDown: e => e.preventDefault(),
        tabIndex: 0
      }, /*#__PURE__*/React.createElement("span", {
        className: classNames(styles['recent-searches-list-icon'])
      }, /*#__PURE__*/React.createElement(ClockIcon, null)), /*#__PURE__*/React.createElement("span", {
        className: classNames(styles['recent-searches-list-element-name'])
      }, element)), /*#__PURE__*/React.createElement("button", {
        className: classNames(styles['recent-searches-list-clear-input']),
        onClick: () => {
          onDeleteRecentSearch(index);
        },
        onMouseDown: e => e.preventDefault()
      }, /*#__PURE__*/React.createElement(ClearQueryIcon, null))));
      return result;
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['recent-searches'])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['recent-searches-headers'])
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles['recent-searches-headers-title'])
  }, dropdownTitle), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles['recent-searches-headers-clear-history']),
    role: "button",
    onMouseDown: e => e.preventDefault(),
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Button, {
    bgColor: "background-transparent",
    fontColor: "font-blue",
    fontWeight: "font-weight-light",
    size: "size-small",
    onClick: onClearHistory,
    onMouseDown: e => e.preventDefault()
  }, dropdownButtonText))), mapRecentSearchesToList());
};
var RecentSearches$1 = RecentSearches;

export { RecentSearches$1 as default };
//# sourceMappingURL=RecentSearches.js.map
